/* Pfeilnavigation fuer die Kachel-Reihe.
   Die Pfeile sind im HTML versteckt und werden erst hier sichtbar gemacht —
   ohne JavaScript bleibt die Reihe normal scrollbar, ohne tote Knoepfe. */
(function () {
  'use strict';

  function start(buehne) {
    var reihe = buehne.querySelector('.sk-kacheln__grid--scroll');
    if (!reihe) return;
    var pfeile = buehne.querySelectorAll('[data-sk-pfeil]');
    if (!pfeile.length) return;

    function schrittweite() {
      var kachel = reihe.querySelector('.sk-kachel');
      if (!kachel) return reihe.clientWidth * 0.8;
      var abstand = parseFloat(getComputedStyle(reihe).columnGap || '20') || 20;
      return kachel.getBoundingClientRect().width + abstand;
    }

    function auffrischen() {
      var maxLinks = reihe.scrollWidth - reihe.clientWidth - 2;
      var scrollbar = reihe.scrollWidth > reihe.clientWidth + 4;
      Array.prototype.forEach.call(pfeile, function (b) {
        var richtung = parseInt(b.getAttribute('data-sk-pfeil'), 10);
        b.hidden = !scrollbar;
        var amEnde = richtung > 0 ? reihe.scrollLeft >= maxLinks : reihe.scrollLeft <= 2;
        b.disabled = amEnde;
      });
    }

    Array.prototype.forEach.call(pfeile, function (b) {
      b.addEventListener('click', function () {
        var richtung = parseInt(b.getAttribute('data-sk-pfeil'), 10);
        reihe.scrollBy({ left: richtung * schrittweite(), behavior: 'smooth' });
      });
    });

    reihe.addEventListener('scroll', auffrischen, { passive: true });
    window.addEventListener('resize', auffrischen);
    if (window.ResizeObserver) new ResizeObserver(auffrischen).observe(reihe);
    auffrischen();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.sk-kacheln__buehne--scroll'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
